(function () {
  'use strict';

  const context = window.RaceCodeAnalyticsContext || {};
  const locale = (document.documentElement.lang || 'en').toLowerCase();
  const market = context.market || '';
  let cartOpenedAt = 0;
  let cartCheckoutStarted = false;

  function clean(detail) {
    return Object.fromEntries(
      Object.entries(detail || {}).filter(([, value]) => value !== undefined && value !== null && value !== '')
    );
  }

  function track(name, detail) {
    const payload = clean({
      ...detail,
      page_type: context.pageType,
      locale,
      market,
      path: window.location.pathname,
      viewport: window.innerWidth < 750 ? 'mobile' : (window.innerWidth < 1008 ? 'tablet' : 'desktop')
    });

    document.dispatchEvent(new CustomEvent('racecode:analytics', { detail: { name, payload } }));

    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ event: name, ...payload });

    if (window.Shopify?.analytics?.publish) {
      try {
        window.Shopify.analytics.publish(name, payload);
      } catch (_) {
        // Custom pixel subscribers can still consume the local theme and dataLayer events.
      }
    }
  }

  function numeric(value, divisor) {
    const parsed = Number(value);
    return Number.isFinite(parsed) ? parsed / (divisor || 1) : undefined;
  }

  function cartSnapshot(element) {
    const checkout = element?.closest?.('rc-cart-drawer-component')?.querySelector('[data-rc-checkout-link]')
      || document.querySelector('rc-cart-drawer-component [data-rc-checkout-link]');

    return {
      item_count: numeric(checkout?.dataset.cartItems),
      value: numeric(checkout?.dataset.cartValue, 100),
      currency: checkout?.dataset.cartCurrency
    };
  }

  function initCartDrawerTracking() {
    const dialog = document.querySelector('rc-cart-drawer-component dialog');
    if (!dialog || dialog.dataset.rcAnalyticsBound === 'true') return;

    dialog.dataset.rcAnalyticsBound = 'true';
    let wasOpen = false;

    const update = () => {
      const isOpen = dialog.open;

      if (isOpen && !wasOpen) {
        cartOpenedAt = Date.now();
        cartCheckoutStarted = false;
        track('rc_cart_view', cartSnapshot(dialog));
      }

      if (!isOpen && wasOpen) {
        track('rc_cart_close', {
          ...cartSnapshot(dialog),
          seconds_open: cartOpenedAt ? Math.max(0, Math.round((Date.now() - cartOpenedAt) / 1000)) : undefined,
          checkout_started: cartCheckoutStarted
        });
      }

      wasOpen = isOpen;
    };

    new MutationObserver(update).observe(dialog, { attributes: true, attributeFilter: ['open'] });
    dialog.addEventListener('close', update);
    update();
  }

  window.RaceCodeAnalytics = { track };

  if (context.pageType === 'product' && context.productId) {
    track('rc_product_view', {
      product_id: context.productId,
      product_handle: context.productHandle,
      product_title: context.productTitle
    });
  }

  initCartDrawerTracking();

  document.addEventListener('click', (event) => {
    const target = event.target instanceof Element ? event.target : event.target?.parentElement;
    if (!target) return;

    const sizeGuide = target.closest('[data-size-chart-open]');
    if (sizeGuide) track('rc_size_guide_open', { product_id: context.productId });

    const quickAdd = target.closest('[data-rc-quick-add-trigger]');
    if (quickAdd) {
      const card = quickAdd.closest('[data-product-id]');
      track('rc_quick_add_open', { product_id: card?.dataset.productId });
    }

    const checkout = target.closest('a[href*="/checkout"], button[name="checkout"], [data-rc-checkout], [data-rc-checkout-link]');
    if (checkout) {
      cartCheckoutStarted = true;
      track('rc_begin_checkout', cartSnapshot(checkout));
    }

    const cartTrigger = target.closest('a[href*="/cart"], [data-cart-drawer-trigger], [data-rc-cart-trigger]');
    if (cartTrigger && !checkout) {
      track('rc_cart_open', { trigger: cartTrigger.dataset.rcCartTrigger || cartTrigger.dataset.cartDrawerTrigger || 'header' });
    }
  });

  document.addEventListener('change', (event) => {
    const sizeInput = event.target.closest('.rc-eme__size-input');
    if (sizeInput?.checked) {
      track('rc_size_selected', {
        product_id: context.productId,
        size: sizeInput.value
      });
    }
  });

  document.addEventListener('racecode:add-to-cart', (event) => {
    track('rc_add_to_cart', event.detail || {});
  });

  document.addEventListener('racecode:ui-error', (event) => {
    track('rc_ui_error', event.detail || {});
  });
})();
